import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const NotificationsTypeIcon = ({result}) => {
    /*
    *
    INFO = "i", _("Info")
    SUCCESS = "s", _("Success")
    WARNING = "w", _("Warning")
    ERROR = "e", _("Error")
    * <i class="fa-solid fa-triangle-exclamation"></i>
    * */
    const getIcon = (key) => {
        const icons = {
            "i": <FontAwesomeIcon icon="info" size={"1x"} className="d-block mt-2 m-auto text-secondary" style={{color: '#22deea',}}/>,
            "s": <FontAwesomeIcon icon="circle-check" size={"1x"} className="d-block mt-2 m-auto text-secondary"/>,
            "w": <FontAwesomeIcon icon="warning-exclamation" size={"1x"} className="d-block mt-2 m-auto" style={{color: '#ffc107',}}/>,
            "e": <FontAwesomeIcon icon="exclamation" size={"1x"} className="d-block mt-2 m-auto" style={{color: '#dc3545',}}/>,
        };
        return icons[key];
    };

    return (getIcon(result))
}
export default NotificationsTypeIcon